module.exports = __webpack_public_path__ + "static/media/ring-sound.ad47ec32.mp3";